/**
 * Класс для работы с Google reCAPTCHA.
 * @class Captcha
 * @param {Object} options - Опции конструктора
 * @param {Function} [callbackOnSuccess] - Колбэк при успешной валидации
 * @param {Function} [callbackOnError] - Колбэк при ошибке валидации
 * @param {string} [captchaType] - Тип капчи (по умолчанию "invisible")
 */
class Captcha {
  constructor({
    callbackOnSuccess = () => {},
    callbackOnError = () => {},
    captchaType = "invisible",
  }) {
    this.callbackOnSuccess = callbackOnSuccess;
    this.callbackOnError = callbackOnError;
    this.captchaType = captchaType;
  }

  /**
   * Запрос к API для верификации токена от grecaptcha.
   * @param {string} recaptchaValue - Токен, который выдается после проверки пользователя
   * @returns {Promise<Object>} Результат проверки
   */
  async _fetchCaptchaVerification(recaptchaValue) {
    const response = await fetch("/api/verify-recaptcha-token", {
      body: JSON.stringify({ recaptchaValue, captchaType: this.captchaType }),
      headers: { "Content-Type": "application/json" },
      method: "POST",
    });

    return response.json();
  }

  /**
   * Валидирует токен reCAPTCHA.
   * @param {string} recaptchaValue - Токен reCAPTCHA
   * @returns {Promise<void>}
   */
  async _validateToken(recaptchaValue) {
    try {
      const res = await this._fetchCaptchaVerification(recaptchaValue);
      if (res.success) {
        await this.callbackOnSuccess();
      } else {
        await this.callbackOnError();
      }
    } catch (error) {
      await this.callbackOnError();
    }
    window.grecaptcha?.reset();
  }

  /**
   * Рендерит капчу на странице.
   */
  renderCaptcha() {
    const head = document.getElementsByTagName("head")[0];
    const captchaScript = document.createElement("script");
    captchaScript.setAttribute("id", "captcha-script");
    captchaScript.setAttribute("src", "https://www.google.com/recaptcha/api.js?render=explicit&hl=ru");
    captchaScript.setAttribute("async", "");
    captchaScript.setAttribute("defer", "");
    head.appendChild(captchaScript);

    const renderAttempt = () => {
      window.grecaptcha?.ready(async () => {
        await window.grecaptcha.render("captcha-element", {
          callback: this._validateToken.bind(this),
        });
      });
    };

    const renderInterval = setInterval(() => {
      if (window.grecaptcha) {
        renderAttempt();
        clearInterval(renderInterval);
      }
    }, 1000);
  }

  /**
   * Запускает валидацию капчи.
   */
  validateCaptcha() {
    window.grecaptcha?.execute();
  }
}

export default Captcha;
